import React from "react";
import PropTypes from "prop-types";
import {AButton, AIcon} from "@cisco-sbg-ui/magna-react";
import classNames from "classnames";

export default function ExternalRouteButton(props) {
  const {
    asLink,
    href,
    target,
    text,
    hideIcon = false,
    title,
    telemetryLabel,
    carryOpenerAndReferrer = false,
    style,
    className,
    ...otherProps
  } = props;

  /* Ensure this is a valid external URL.
    Disallow javascript in url and relative urls. */
  const isValidExternalURL = (input) => {
    if (!input) return false; // prevent throwing error when no input is passed. just dont show it
    let url;
    try {
      url = new URL(input);
    } catch (_) {
      console.warn(
        `Improperly formatted input ${input} passed to External Route Button.`
      );
      return false;
    }
    return url.protocol === "http:" || url.protocol === "https:";
  };

  const validUrl = isValidExternalURL(href);

  const Component = asLink ? "a" : AButton;

  return validUrl ? (
    <Component
      {...(!asLink && {tertiary: true})}
      href={href}
      onClick={(e) => {
        e.stopPropagation();
      }}
      rel={carryOpenerAndReferrer ? "" : `noopener noreferrer`}
      target={target ? target : "_blank"}
      title={title || href}
      className={classNames("pa-0 d-inline", className)}
      style={style}
      test-data-id={"ExternalRouteButton"}
      {...otherProps}>
      {text}
      {!hideIcon && (
        <AIcon size={12} className="ml-1">
          arrow-square-out
        </AIcon>
      )}
    </Component>
  ) : (
    <span data-url={href} style={{margin: 0}}>
      {text}
    </span>
  );
}

ExternalRouteButton.propTypes = {
  /**
   * Determines if the component should render as a link
   * instead of a button.
   */
  asLink: PropTypes.bool,

  /* URL to be used for the button */
  href: PropTypes.string,
  /**
   * Default: "_blank"
   * Option to pass in an alternative target attribute
   */
  /**
   * Default: false
   * If true, the new window icon will be hidden
   */
  hideIcon: PropTypes.bool,
  target: PropTypes.string,
  /**
   * Text to show in the button
   *
   * Accepts an array to account for markdown links
   */
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired
};
